import { Icon } from '../Icon/Icon';

type SocialMedia = 'facebook' | 'twitter' | 'instagram' | 'youtube';

const mediaIcon: { [key in SocialMedia]: { width: number; height: number } } = {
  facebook: {
    width: 20,
    height: 20,
  },
  twitter: {
    width: 18,
    height: 18,
  },
  instagram: {
    width: 20,
    height: 20,
  },
  youtube: {
    width: 24,
    height: 17,
  },
};

const urls: { [key in SocialMedia]: { url: string } } = {
  facebook: {
    url: 'https://www.facebook.com/derfreitag/',
  },
  twitter: {
    url: 'https://twitter.com/derfreitag/',
  },
  instagram: {
    url: 'https://www.instagram.com/freitag/',
  },
  youtube: {
    url: 'https://www.youtube.com/channel/UCqs44Wf09ppRItc5uqNBMxA',
  },
};

type Props = {
  socialMedia?: SocialMedia[];
};

export const SocialLinks = ({
  socialMedia = ['facebook', 'twitter', 'instagram'],
}: Props) => {
  return (
    <ul className="bo-social-links">
      {socialMedia.map(name => (
        <li className="bo-social-links__item" key={name} data-testid={name}>
          <a href={urls[name].url} target="_blank" rel="noopener noreferrer">
            <Icon
              iconName={name}
              width={mediaIcon[name].width}
              height={mediaIcon[name].height}
            />
          </a>
        </li>
      ))}
    </ul>
  );
};
